import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  CorrectionsModal,
  DateSelector,
  FullTable,
  FullTableAccordion,
  SimpleModal,
  TabButtons,
  TableWrapper,
} from 'components';
import { httpRequestsOnSuccessActions, loadActions, LoadServices } from 'store';
import {
  billingsBody,
  billingsHead,
  ACTION_TYPE,
  BILLABLE,
  groupBillingsHead,
  groupBillingsBody,
  groupBillingsLoadsBody,
  BILLING_GROUPS_ACTION_TYPE,
  billingPrepaidHead,
  billingPrepaidBody,
  ACTION_TYPE_GET_BILLING_PREPAID_LOADS, ACTION_TYPE_SET_PREPAY_BILLED,
} from './constants';
import { SubmitBillModal } from '../../fragments/billing/billingDetails/core';
import { LoadDetailSwitcher, RENDER_LOADS } from '../loads';
import { FindSuccessItem, usePrimaryModal, useTertiaryModal } from '../../utils';
import { receivablesTabEnums, receivablesTabParams } from './receivables/constants';
import { getBillingGroups } from '../../store/loads/loads.action';
import { GET_BILLING_GROUP_LOADS } from '../../store/loads/loads.types';
import { GroupedLoadDetails } from '../../fragments';

export const Billing = ({}) => {
  const { loadsList, billingGroups, billingGroupLoads, billingPrepaidLoads } = useSelector((state) => ({
    loadsList: state.loads.loadsList,
    billingGroups: state.loads.billingGroups,
    billingGroupLoads: state.loads.billingGroupLoads,
    billingPrepaidLoads: state.loads.billingPrepaidLoads,
  }));
  const history = useHistory();
  const info = history?.location?.state;
  const dispatch = useDispatch();
  const [openSubmitBill, setOpenSubmitBill] = useState(false);
  const [openCorrection, setOpenCorrection] = useState(false);
  const [loadCorrect, setLoaderCorrect] = useState(false);
  const [correction, setCorrection] = useState('');
  const [loadId, setLoadId] = useState(null);
  // const [load, setLoad] = useState(null);
  const [data, setData] = useState();
  const { openPrimary } = usePrimaryModal();
  const { openTertiary } = useTertiaryModal();
  const renderLoads = FindSuccessItem(RENDER_LOADS);
  const successSetPrepay = FindSuccessItem(ACTION_TYPE_SET_PREPAY_BILLED);
  const billingTab = info?.viewType ? info?.viewType : receivablesTabEnums.LOADS;
  const renderParams = () => {
    const filteredInfo = {
      ...info,
    };
    filteredInfo.skip = info?.skip ? info?.skip : 0;
    filteredInfo.limit = 100;
    delete filteredInfo.page;
    delete filteredInfo.activeTab;
    delete filteredInfo.viewType;
    return filteredInfo;
  };

  useEffect(() => {
    handleGet('loading');
    const interval = setInterval(() => {
      handleGet('noLoad');
    }, 30000);
    return () => clearInterval(interval);
  }, [info]);

  useEffect(() => {
    if (renderLoads) {
      dispatch(httpRequestsOnSuccessActions.removeSuccess(RENDER_LOADS));
      handleGet('noLoad');
    }
  }, [renderLoads]);

  useEffect(() => {
    if (successSetPrepay?.type) {
      dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE_SET_PREPAY_BILLED));
      handleGet('noLoad');
    }
  }, [successSetPrepay]);

  const handleGet = (loading) => {
    const loader = loading === 'loading' ? 'loading' : 'noLoad';
    const filteredInfo = renderParams();

    if (billingTab === receivablesTabEnums.LOADS) {
      dispatch(loadActions.getLoadsByStatus({ ...filteredInfo, department: BILLABLE }, loader));
    }

    if (billingTab === receivablesTabEnums.LOAD_GROUPS) {
      dispatch(loadActions.getBillingGroups({ ...filteredInfo, billStatus: BILLABLE, readyForBilling: true }, loader));
    }

    if (billingTab === receivablesTabEnums.LOAD_PREPAID) {
      dispatch(loadActions.getBillingPrepaidLoads({ ...filteredInfo }, loader));
    }
  };

  const handleClose = () => {
    setOpenSubmitBill(!openSubmitBill);
    setData(null);
    setLoadId(null);
  };

  const handleSubmit = async (info, name) => {
    setLoadId(info?.id);
    const params = {
      ...info,
    };

    try {
      if (name === 'billed') {
        // dispatch(loadActions.setPrepayBilled(info?.id, { isPrepayBilled: !info?.isPrepayBilled }));
        await LoadServices.setPrepayBilled(info?.id, { isPrepayBilled: !info?.isPrepayBilled });
        dispatch(httpRequestsOnSuccessActions.appendSuccess(RENDER_LOADS));
      } else {
        const res =
          billingTab === receivablesTabEnums.LOADS ?
            await LoadServices.getBillingDock(info?.id, correction)
            :
            await LoadServices.getGroupBillingDock(info?.id, correction);


        // const res = await LoadServices.getBillingDock(info?.id, correction);
        params.bill = {
          lastInvoiceDocs: {
            url: res?.data?.url || '',
          },
        };
        setData(params);
        setOpenSubmitBill(!openSubmitBill);
      }

      setLoadId(null);
    } catch (e) {
      setLoadId(null);
    }
    // setData(e)
    // setOpenSubmitBill(!openSubmitBill)
  };

  const handleOpenCorrection = (load) => {
    setData(load ? load : null);
    setOpenCorrection(!openCorrection);
  };

  const handleSend = async () => {
    setLoaderCorrect(true);
    try {
      await LoadServices.SendBillingCorrection(data?.id, correction);
      handleGet('noLoad');
      dispatch(httpRequestsOnSuccessActions.appendSuccess('CORRECTION_SENDED'));
      setLoaderCorrect(false);
      setOpenCorrection(false);
      setOpenSubmitBill(false);
    } catch (e) {
      setLoaderCorrect(false);
    }
  };

  const openModals = (id, name) => {
    if (name === 'loadGroup') {
      openTertiary(<GroupedLoadDetails id={id} />);
    }
    if (name === 'load') {
      openPrimary(<LoadDetailSwitcher loadId={id} />);
    }
    // history.push({
    //     pathname: `/load/${id}`,
    //     state: {loadParams: {...info}, parent: '/billing', detail: 'billing',}
    // })
  };

  return (
    <div>

      <TableWrapper
        buttonsTab={true}
        link={true}
        tab={'none'}
        buttonsTabAddButton={false}
      >
        <div className="space-between">
          <TabButtons
            tabParams={receivablesTabParams}
            resetParams={true}
          />

          {billingTab !== receivablesTabEnums.LOAD_PREPAID &&
            <DateSelector
              startName={'from'}
              endName={'to'}
            />
          }
        </div>


        {billingTab === receivablesTabEnums.LOADS &&
          <FullTable
            head={billingsHead}
            body={billingsBody(loadId)}
            loadingType={ACTION_TYPE}
            list={loadsList?.loads}
            listCount={loadsList?.count}
            handleClick={(id) => openModals(id, 'load')}
            noText={'Billing'}
            handleClickButton={handleSubmit}
          />
        }

        {billingTab === receivablesTabEnums.LOAD_GROUPS &&
          <FullTableAccordion
            head={groupBillingsHead}
            body={groupBillingsBody(loadId, openModals)}
            handleRowClick={(id) => {
              dispatch(loadActions.getBillingGroupLoads(id));
            }}
            renderDetails={() =>
              <div className="accordion-full-table-wrapper">
                <FullTable
                  // height={'small'}
                  head={billingsHead}
                  body={groupBillingsLoadsBody()}
                  loadingType={GET_BILLING_GROUP_LOADS}
                  list={billingGroupLoads}
                  // handleClick={(id) => openModals(id, 'loadGroup')}
                  // handleClick={pushPageDetails}
                  noText={'Loads'}
                  handleClickButton={handleOpenCorrection}
                  fixHeight="45vh"
                  margin={'0px'}
                  padding={'8px'}
                  paddingHead={'8px'}
                />
              </div>
            }
            loadingType={BILLING_GROUPS_ACTION_TYPE}
            list={billingGroups?.loadGroups}
            listCount={billingGroups?.count}
            fixHeight={billingGroups?.count ? '64vh' : '72vh'}
            noText={'Billing'}
            handleClickButton={handleSubmit}
          />
        }
        {billingTab === receivablesTabEnums.LOAD_PREPAID &&
          <FullTable
            head={billingPrepaidHead}
            body={billingPrepaidBody(loadId)}
            loadingType={ACTION_TYPE_GET_BILLING_PREPAID_LOADS}
            list={billingPrepaidLoads?.loads}
            listCount={billingPrepaidLoads?.count}
            handleClick={(item) => openModals(item?.id, 'load')}
            noText={'Prepaid'}
            clickType='item'
            handleClickButton={handleSubmit}
          />
        }
      </TableWrapper>

      <SimpleModal
        handleOpenClose={handleClose}
        openDefault={openSubmitBill}
        content={
          <SubmitBillModal
            viewType={billingTab}
            handleGet={handleGet}
            bill={true}
            handleSend={handleOpenCorrection}
            loadById={data}
            handleClose={handleClose}
          />
        }
      />

      <SimpleModal
        handleOpenClose={() => setOpenCorrection(false)}
        openDefault={openCorrection}
        content={
          <CorrectionsModal
            info={data}
            handleChangeText={(e) => setCorrection(e)}
            loadingCor={loadCorrect}
            handleSend={handleSend}
            type={'notVerified'}
            handleClose={() => setOpenCorrection(false)}
          />
        }
      />
    </div>
  );
};